import React from 'react';
export var lazyLoader = function lazyLoader(lazyComponent) {
  return /*#__PURE__*/React.lazy(function () {
    return recursiveLazyLoader(lazyComponent, 3);
  });
};
var recursiveLazyLoader = function recursiveLazyLoader(lazyComponent, attemptsLeft) {
  return new Promise(function (resolve, reject) {
    lazyComponent().then(resolve).catch(function (error) {
      console.error("Failed loading chunck! Retrting. (".concat(attemptsLeft, " attempts left)"), error);
      // let us retry after 1500 ms
      if (attemptsLeft <= 1) {
        return saveReloadPage(function () {
          return reject(error);
        });
      } else {
        setTimeout(function () {
          recursiveLazyLoader(lazyComponent, attemptsLeft - 1).then(resolve, reject);
        }, 1500);
      }
    });
  });
};
var saveReloadPage = function saveReloadPage(reject) {
  if (typeof window !== 'undefined') {
    var pageHasAlreadyBeenForceRefreshed = JSON.parse(sessionStorage.getItem('page-has-been-force-refreshed') || 'false');
    if (!pageHasAlreadyBeenForceRefreshed) {
      // Assuming that the user is not on the latest version of the application.
      // Let's refresh the page immediately.
      sessionStorage.setItem('page-has-been-force-refreshed', 'true');
      return window.location.reload();
    }
  }
  reject();
};